import { Fragment, SetStateAction, useState } from 'react'
import { useParams } from 'react-router-dom'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useEditDeleteModal from '../../../../../../utils/hooks/useEditDeleteModal'
import { OnSubmit } from '../../../../../../forms/TwinForm/types'
import { TableInstanceType } from '../../../../../../baseComponents/TwinTable/types'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import ModalCreateCustomerCampaign from '../../../CustomerCampaigns/ModalCreateCustomerCampaign'
import ModalEditCampaignCustomer from '../../../../../ModalEditCampaignCustomer'
import { CustomerDashboardAddButton, CustomerDashboardSeeAllLink } from '../../SpecificComponents'
import { getUserPermissions } from '../../../../../../utils/reducers/getters'
import { TableCustomerCampaignsConnect } from '../../../CustomerCampaigns'

interface CustomerCampaignsDashboardProps extends CustomerCampaignsDashboardLogicProps {
    title: string
    allRowData: CustomerModelType
}

const CustomerCampaignsDashboard: React.FC<CustomerCampaignsDashboardProps> = ({ title, allRowData }) => {
    const { t } = useTwinTranslation()
    const { setTableInstance, tableInstance } = useCustomerCampaignsDashboardLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const userPermissions = getUserPermissions('customer.profile.campaign')
    return (
        <div className='flex flex-col flex-auto gap-10'>
            <div className='flex flex-wrap justify-between gap-5'>
                <div className='flex items-center gap-x-10'>
                    <h3>{title}</h3>
                    <CustomerDashboardSeeAllLink customerTab='campaigns' customerType={allRowData?.customer_type} />
                </div>
                <CustomerDashboardAddButton userPermissions={userPermissions || { n: 4, permission: 'delete' }} CreateModalComponent={ModalCreateCustomerCampaign} onSubmit={updateTableInstance} text={t('newCampaign', 'Nueva campaña')} />
            </div>
            <TableCustomerCampaignsDashboard userPermissions={userPermissions || { n: 4, permission: 'delete' }} onSubmit={updateTableInstance} setTableInstance={setTableInstance} tableInstance={tableInstance} />
        </div>
    )
}

interface CustomerCampaignsDashboardLogicProps { }

const useCustomerCampaignsDashboardLogic = () => {
    const [tableInstance, setTableInstance] = useState<TableInstanceType>(null)
    return { setTableInstance, tableInstance }
}

interface TableCustomerCampaignsDashboardProps extends ComponentWithPermissions {
    onSubmit: OnSubmit
    setTableInstance: React.Dispatch<SetStateAction<TableInstanceType>>
    tableInstance: TableInstanceType
}

const TableCustomerCampaignsDashboard: React.FC<TableCustomerCampaignsDashboardProps> = ({ onSubmit, setTableInstance, userPermissions, tableInstance }) => {
    const { id } = useParams()
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <Fragment>
            <TableCustomerCampaignsConnect name='CustomerCampaignCustomersDashboard' className='small_simple_table' hideLoadFiltersButton={true} extraWhereParams={{ CustomerId: id }} setTableInstance={setTableInstance} setOpened={setOpenModal} tableInstance={tableInstance} userPermissions={userPermissions} />
            {openModal?.type === 'edit' && <ModalEditCampaignCustomer {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} userPermissions={userPermissions} allRowData={openModal?.allRowData} basicData={{}} />}
        </Fragment>
    )
}

export default CustomerCampaignsDashboard